import ContainerComponent from '@/components/common/notes/show-note-forms/form-components/container-component';

interface Props {
    item: {
        label: string;
        subtype: string;
    };
}

const HeaderFieldComponent = ({ item: { label, subtype } }: Props) => {
    return <ContainerComponent header={label} subtype={subtype} />;
};

export default HeaderFieldComponent;
